/**
 * Free Gift With Purchase - auto add / auto remove
 *
 * Gift Product ID: 8353806581849
 * Gift Variant ID: 44551555743833
 * Trigger: qualifying cart subtotal reaches $1,000.00
 *
 * Product ID is used to identify the gift in the cart.
 * Variant ID is used when adding the gift because Shopify's
 * Cart API requires a variant ID.
 *
 * Emits 'free-gift:state' on document after every sync;
 * snippets/free-gift.liquid listens to it.
 *
 * The gift is zeroed by a native automatic "Buy X Get Y" discount.
 * Without that discount the customer WILL be charged $50.
 */

(function () {
  'use strict';

  var DEFAULTS = {
    // Shopify PRODUCT ID
    giftProductId: 8353806581849,

    // Shopify VARIANT ID that should be added to cart
    giftVariantId: 44551555743833,

    // $1,000.00
    thresholdCents: 100000,

    propertyKey: '_free_gift',
    propertyValue: 'true',

    respectManualRemoval: true,
    debounceMs: 300,
    debug: false
  };

  var CONFIG = Object.assign({}, DEFAULTS, window.FREE_GIFT_CONFIG || {});

  function log() {
    if (!CONFIG.debug) return;

    console.log.apply(
      console,
      ['[free-gift]'].concat([].slice.call(arguments))
    );
  }

  /*
   * Validate configuration
   */
  if (
    !CONFIG.giftProductId ||
    typeof CONFIG.giftProductId !== 'number'
  ) {
    console.warn(
      '[free-gift] giftProductId is not set - script is idle.'
    );
    return;
  }

  if (
    !CONFIG.giftVariantId ||
    typeof CONFIG.giftVariantId !== 'number'
  ) {
    console.warn(
      '[free-gift] giftVariantId is not set - script is idle.'
    );
    return;
  }

  var DISMISS_KEY =
    'gwp_dismissed_' + CONFIG.giftProductId;

  var JSON_HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };

  var syncing = false;
  var timer = null;
  var lastGiftKey = null;

  /*
   * Keep native fetch.
   */
  var nativeFetch = window.fetch.bind(window);

  /*
   * Identify gift by PRODUCT ID.
   *
   * This is the important change:
   *
   * item.product_id === CONFIG.giftProductId
   *
   * instead of:
   *
   * item.variant_id === CONFIG.giftVariantId
   */
  function isGiftLine(item) {
    return (
      Number(item.product_id) === Number(CONFIG.giftProductId) &&
      item.properties &&
      String(item.properties[CONFIG.propertyKey]) ===
        CONFIG.propertyValue
    );
  }

  /*
   * Calculate qualifying cart subtotal.
   * Gift product is excluded from the qualifying total.
   */
  function getCustomPriceCents(item) {
    if (!item || !item.properties) return 0;
    var keys = ['_custom_price', 'custom_price', 'Custom Price', 'customPrice'];

    for (var i = 0; i < keys.length; i++) {
      var value = item.properties[keys[i]];
      if (value === undefined || value === null || value === '') continue;
      var number = parseFloat(String(value).replace(/[^0-9.-]/g, ''));
      if (!isNaN(number) && number > 0) return Math.round(number * 100);
    }
    return 0;
  }

  function qualifyingTotal(cart) {
    var total = 0;

    var giftEl =
      document.querySelector('.aya-gift[data-product-id]');

    /*
     * AYA CUSTOM PRICING PRODUCT PAGE:
     * The currently selected variation's live custom price is the
     * qualifying amount. This is intentionally checked first so
     * an unrelated cart subtotal cannot unlock the gift.
     */
    if (giftEl) {
      var livePrice = Number(window.lastCalculatedPrice);
      var renderedPrice = Number(giftEl.getAttribute('data-product-price'));

      if (isFinite(livePrice) && livePrice >= 0) {
        return Math.round(livePrice * 100);
      }

      if (isFinite(renderedPrice) && renderedPrice >= 0) {
        return Math.round(renderedPrice * 100);
      }
    }

    /*
     * Cart / non-product-page fallback:
     * custom line price first, Shopify line price second.
     */
    if (!cart || !cart.items) {
      cart = { items: [] };
    }

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];

      if (isGiftLine(item)) {
        continue;
      }

      var customPriceCents = getCustomPriceCents(item);

      if (customPriceCents > 0) {
        total += customPriceCents * item.quantity;
      } else {
        total += item.final_line_price;
      }
    }

    return total;
  }
  /*
   * Notify the frontend/snippet.
   */
  function announce(total, qualifies, present) {
    document.dispatchEvent(
      new CustomEvent('free-gift:state', {
        detail: {
          total: total,
          threshold: CONFIG.thresholdCents,
          remaining: Math.max(
            0,
            CONFIG.thresholdCents - total
          ),
          qualifies: qualifies,
          present: present
        }
      })
    );
  }

  /*
   * Check whether customer manually dismissed the gift.
   */
  function isDismissed() {
    if (!CONFIG.respectManualRemoval) {
      return false;
    }

    try {
      return (
        sessionStorage.getItem(DISMISS_KEY) === '1'
      );
    } catch (e) {
      return false;
    }
  }

  /*
   * Set/remove manual dismissal.
   */
  function setDismissed(value) {
    try {
      if (value) {
        sessionStorage.setItem(DISMISS_KEY, '1');
      } else {
        sessionStorage.removeItem(DISMISS_KEY);
      }
    } catch (e) {
      // Private mode / unavailable storage
    }
  }

  /*
   * Get current Shopify cart.
   */
  function getCart() {
    return nativeFetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('cart.js ' + res.status);
      }

      return res.json();
    });
  }

  /*
   * ADD GIFT
   *
   * Shopify requires the VARIANT ID here.
   */
  function addGift() {
    var props = {};

    props[CONFIG.propertyKey] =
      CONFIG.propertyValue;

    /*
     * AYA custom gift price.
     *
     * This makes the gift display as $0
     * in the AYA cart and lets the custom
     * checkout flow override the draft-order
     * line price to $0.00.
     */
    props._custom_price = '0.00';

    props['Free Gift'] = 'Yes';

    return nativeFetch('/cart/add.js', {
      method: 'POST',
      headers: JSON_HEADERS,
      credentials: 'same-origin',

      body: JSON.stringify({
        items: [
          {
            id: CONFIG.giftVariantId,
            quantity: 1,
            properties: props
          }
        ]
      })
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('add.js ' + res.status);
      }

      return res.json();
    });
  }

  /*
   * Change cart line quantity.
   */
  function setLineQuantity(key, quantity) {
    return nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: JSON_HEADERS,
      credentials: 'same-origin',

      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    }).then(function (res) {
      if (!res.ok) {
        throw new Error(
          'change.js ' + res.status
        );
      }

      return res.json();
    });
  }

  /*
   * Refresh cart UI.
   */
  function refreshUI() {
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:build', {
        bubbles: true
      })
    );

    /*
     * If customer is on /cart,
     * reload so cart page reflects changes.
     */
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    }
  }

  /*
   * MAIN SYNC
   */
  function sync() {
    if (syncing) {
      return Promise.resolve();
    }

    syncing = true;

    return getCart()
      .then(function (cart) {
        var giftLine = null;

        /*
         * Find gift by PRODUCT ID.
         */
        for (
          var i = 0;
          i < cart.items.length;
          i++
        ) {
          if (isGiftLine(cart.items[i])) {
            giftLine = cart.items[i];
            break;
          }
        }

        /*
         * Calculate qualifying subtotal.
         */
        var total = qualifyingTotal(cart);

        /*
         * Check $1,000 threshold.
         */
        var qualifies =
          total >= CONFIG.thresholdCents;

        /*
         * Remember gift cart line key.
         */
        lastGiftKey = giftLine
          ? giftLine.key
          : null;

        announce(
          total,
          qualifies,
          !!giftLine
        );

        log(
          'subtotal:',
          total,
          'qualifies:',
          qualifies,
          'gift present:',
          !!giftLine
        );

        /*
         * CUSTOMER QUALIFIES
         *
         * Add gift if it isn't already in cart.
         */
        if (
          qualifies &&
          !giftLine &&
          !isDismissed()
        ) {
          return addGift().then(function () {
            announce(
              total,
              true,
              true
            );

            refreshUI();
          });
        }

        /*
         * CUSTOMER QUALIFIES + GIFT ALREADY EXISTS
         *
         * If an older gift line was added before the
         * zero-price implementation, remove and re-add
         * it so it receives:
         *
         * _free_gift = true
         * _custom_price = 0.00
         */
        if (
          qualifies &&
          giftLine &&
          String(
            giftLine.properties &&
            giftLine.properties._custom_price ||
            ''
          ) !== '0.00' &&
          !isDismissed()
        ) {
          return setLineQuantity(
            giftLine.key,
            0
          ).then(function () {
            return addGift();
          }).then(function () {
            announce(
              total,
              true,
              true
            );

            refreshUI();
          });
        }

        /*
         * CUSTOMER NO LONGER QUALIFIES
         *
         * Remove gift automatically.
         */
        if (!qualifies && giftLine) {
          return setLineQuantity(
            giftLine.key,
            0
          ).then(function () {
            setDismissed(false);

            announce(
              total,
              false,
              false
            );

            refreshUI();
          });
        }

        /*
         * Prevent customer from having more than
         * one free gift.
         */
        if (
          giftLine &&
          giftLine.quantity > 1
        ) {
          return setLineQuantity(
            giftLine.key,
            1
          ).then(refreshUI);
        }
      })
      .catch(function (err) {
        console.warn(
          '[free-gift]',
          err.message
        );
      })
      .then(function () {
        syncing = false;
      });
  }

  /*
   * Debounce sync.
   */
  function scheduleSync() {
    clearTimeout(timer);

    timer = setTimeout(
      sync,
      CONFIG.debounceMs
    );
  }

  /*
   * Shopify cart mutation URLs.
   */
  var CART_MUTATION =
    /\/cart\/(add|change|update|clear)(\.js)?/;

  /*
   * Detect manual gift removal.
   */
  function noteManualRemoval(body) {
    if (
      syncing ||
      !lastGiftKey ||
      !body
    ) {
      return;
    }

    try {
      var parsed =
        typeof body === 'string'
          ? JSON.parse(body)
          : null;

      if (
        parsed &&
        parsed.id === lastGiftKey &&
        Number(parsed.quantity) === 0
      ) {
        setDismissed(true);
      }
    } catch (e) {
      // Not JSON
    }
  }

  /*
   * Observe fetch cart mutations.
   */
  window.fetch = function () {
    var args = arguments;
    var url = '';

    try {
      url =
        typeof args[0] === 'string'
          ? args[0]
          : (args[0] && args[0].url) || '';
    } catch (e) {
      // Treat as non-cart request
    }

    /*
     * Non-cart requests pass through untouched.
     */
    if (!CART_MUTATION.test(url)) {
      return nativeFetch.apply(
        null,
        args
      );
    }

    /*
     * Detect manual removal.
     */
    try {
      noteManualRemoval(
        args[1] &&
        args[1].body
      );
    } catch (e) {
      // Observation only
    }

    /*
     * Execute original request.
     */
    return nativeFetch
      .apply(null, args)
      .then(function (response) {
        if (!syncing) {
          scheduleSync();
        }

        return response;
      });
  };

  /*
   * Observe XMLHttpRequest cart mutations.
   */
  var nativeOpen =
    XMLHttpRequest.prototype.open;

  var nativeSend =
    XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open =
    function (method, url) {
      try {
        this.__isCartMutation =
          CART_MUTATION.test(
            String(url)
          );
      } catch (e) {}

      return nativeOpen.apply(
        this,
        arguments
      );
    };

  XMLHttpRequest.prototype.send =
    function (body) {
      if (this.__isCartMutation) {
        try {
          noteManualRemoval(body);
        } catch (e) {}

        this.addEventListener(
          'load',
          function () {
            if (!syncing) {
              scheduleSync();
            }
          }
        );
      }

      return nativeSend.apply(
        this,
        arguments
      );
    };

  window.addEventListener('aya:custom_price_updated', function () {
    scheduleSync();
  });

  /*
   * Initial sync.
   */
  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleSync
    );
  } else {
    scheduleSync();
  }

  /*
   * Public API.
   */
  window.FreeGift = {
    sync: sync,

    reset: function () {
      setDismissed(false);
      sync();
    },

    config: CONFIG
  };
})();
